import React from 'react';
import PropTypes from 'prop-types';
import { LinksForUserProfile } from '../UserDetails.styles';
import UserIcon from '../../Visuals/Icons/UserIcon.icon';
import ReceiptIcon from '../../Visuals/Icons/ReceiptIcon.icon';
import EditIcon from '../../Visuals/Icons/EditIcon.icon';
import PresentationIcon from '../../Visuals/Icons/PresentationIcon.icon';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';

const UserDetailsSideMenu = ({ setSelectedSection, selectedSection }) => {
  return (
    <LinksForUserProfile>
      <BreadCrumbs
        one="Company Dashboard"
        oneLink="/company"
        two="User Details"
      />
      <div className="links">
        <p
          className={`courseHover${selectedSection === 'details' ? ' selected' : ''}`}
          onClick={() => setSelectedSection('details')}
        >
          <UserIcon />
          Details
        </p>
        <p
          className={`courseHover${selectedSection === 'edit' ? ' selected' : ''}`}
          onClick={() => setSelectedSection('edit')}
        >
          <EditIcon />
          Edit
        </p>
        <p
          className={`courseHover${selectedSection === 'purchased' ? ' selected' : ''}`}
          onClick={() => setSelectedSection('purchased')}
        >
          <ReceiptIcon />
          Purchase History
        </p>
        <p
          className={`courseHover${selectedSection === 'courses' ? ' selected' : ''}`}
          onClick={() => setSelectedSection('courses')}
        >
          <PresentationIcon />
          Courses
        </p>
      </div>
    </LinksForUserProfile>
  );
};

UserDetailsSideMenu.propTypes = {
  user: PropTypes.object,
  setSelectedSection: PropTypes.func,
  selectedSection: PropTypes.string, // <-- Add this prop
};

export default UserDetailsSideMenu;
